import React, { useEffect, useState, useRef, lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';

// constants
import LocalStrings from '../../languages';
import Loader from '../../components/Common/loader';

// actions
import {
  fetchTickets,
  fetchMyProfile,
  fetchContentTabs,
  fetchEventForms,
  fetchInterests
} from '../../actions';
import { fetchProductAllCategory, fetchProductAllSubCategory } from './actions';

// components
// import Profile from './components/profile';
const LazyProfile = lazy(() => import('./components/profile'));
// import Speaker from './components/speaker';
const LazySpeaker = lazy(() => import('./components/speaker'));
// import Sponsor from './components/sponsor';
const LazySponsor = lazy(() => import('./components/sponsor'));
// import Exhibitor from './components/exhibitor';
const LazyExhibitor = lazy(() => import('./components/exhibitor'));

const MyProfile = props => {
  const {
    session,
    userDetails,
    isShowOnlyProfile,
    isShowSpeaker,
    isShowSponsor,
    isShowExhibitor,
    speakerText,
    sponsorText,
    exhibitorText,
    deviceSize,
    location,
    outSideCall = false
  } = props;

  const [activeTab, setActiveTab] = useState('1');
  const [isAppCall, setIsAppCall] = useState(false);

  useEffect(() => {
    props.fetchInterests(session, res => {});
    props.fetchEventForms(session, res => {});
    props.fetchContentTabs(session, res => {});

    if (location?.search) {
      setIsAppCall(true);
    } else {
      setIsAppCall(false);
      props.fetchTickets(session, res => {});
      props.fetchMyProfile(session);
    }
  }, []);

  useEffect(() => {
    if (activeTab === '4') {
      props.fetchProductAllCategory(session, res => {});
      props.fetchProductAllSubCategory(session, res => {});
    }
  }, [activeTab]);

  const _toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    // Myprofile is called inside vs_popup thats why we are using outSideCall props to mangae some ui

    <>
      {!_.isEmpty(userDetails) ? (
        isShowOnlyProfile ? (
          <div
            className={`${
              outSideCall
                ? ''
                : 'content-body scrollable-content- scrollbar-hide-no-maxheight'
            } my-profile-container`}
            style={{
              height: deviceSize.isMobile
                ? deviceSize.height - (isAppCall ? 80 : 170)
                : deviceSize.height - 64
              // overflowY: 'scroll'
            }}
          >
            {/* <Profile isAppCall={isAppCall} /> */}
            <Suspense fallback={<Loader />}>
              <LazyProfile isAppCall={isAppCall} />
            </Suspense>
          </div>
        ) : (
          <>
            {/* <Suspense fallback={<Loader />}> */}
            <div
              className={`${
                outSideCall ? '' : 'content-body'
              } my-profile-container`}
            >
              {/* ----------- navbar section ----------- */}
              <Nav tabs className="hs-wrapper flex-nowrap">
                {/* ------ profile ------ */}
                <NavItem>
                  <NavLink
                    className={classnames('custom-text1-medium', {
                      active: activeTab === '1'
                    })}
                    onClick={() => {
                      _toggle('1');
                    }}
                  >
                    {LocalStrings.profile_text_profile}
                  </NavLink>
                </NavItem>

                {/* ------ speaker ------ */}
                {isShowSpeaker ? (
                  <NavItem>
                    <NavLink
                      className={classnames('custom-text1-medium', {
                        active: activeTab === '2'
                      })}
                      onClick={() => {
                        _toggle('2');
                      }}
                    >
                      {speakerText}
                    </NavLink>
                  </NavItem>
                ) : (
                  ''
                )}

                {/* ------ sponsor ------ */}
                {isShowSponsor ? (
                  <NavItem>
                    <NavLink
                      className={classnames('custom-text1-medium', {
                        active: activeTab === '3'
                      })}
                      onClick={() => {
                        _toggle('3');
                      }}
                    >
                      {sponsorText}
                    </NavLink>
                  </NavItem>
                ) : (
                  ''
                )}

                {/* ------ exhibitor ------ */}
                {isShowExhibitor ? (
                  <NavItem>
                    <NavLink
                      className={classnames('custom-text1-medium', {
                        active: activeTab === '4'
                      })}
                      onClick={() => {
                        _toggle('4');
                      }}
                    >
                      {exhibitorText}
                    </NavLink>
                  </NavItem>
                ) : (
                  ''
                )}
              </Nav>

              {/* -------- components rendering - main body -------- */}
              <TabContent activeTab={activeTab}>
                {/* ------ profile ------ */}
                <TabPane
                  tabId="1"
                  className={`${
                    outSideCall
                      ? ''
                      : 'scrollable-content- scrollbar-hide-no-maxheight'
                  }`}
                  style={{
                    height: deviceSize.isMobile
                      ? deviceSize.height - (isAppCall ? 130 : 220)
                      : deviceSize.height - 170
                  }}
                >
                  {activeTab == 1 ? (
                    <>
                      {/* <Profile isAppCall={isAppCall} />  */}
                      <Suspense fallback={<Loader />}>
                        <LazyProfile isAppCall={isAppCall} />
                      </Suspense>
                    </>
                  ) : null}
                </TabPane>

                {/* ------ speaker ------ */}
                <TabPane
                  tabId="2"
                  className={`${
                    outSideCall
                      ? ''
                      : 'scrollable-content- scrollbar-hide-no-maxheight'
                  }`}
                  style={{
                    height: deviceSize.isMobile
                      ? deviceSize.height - (isAppCall ? 130 : 220)
                      : deviceSize.height - 170
                  }}
                >
                  {activeTab == 2 ? (
                    <>
                      {/* <Speaker isAppCall={isAppCall} /> */}
                      <Suspense fallback={<Loader />}>
                        <LazySpeaker isAppCall={isAppCall} />
                      </Suspense>
                    </>
                  ) : null}
                </TabPane>

                {/* ------ sponsor ------ */}
                <TabPane
                  tabId="3"
                  className={`${
                    outSideCall
                      ? ''
                      : 'scrollable-content- scrollbar-hide-no-maxheight'
                  }`}
                  style={{
                    height: deviceSize.isMobile
                      ? deviceSize.height - (isAppCall ? 130 : 220)
                      : deviceSize.height - 170
                  }}
                >
                  {activeTab == 3 ? (
                    <>
                      {/* <Sponsor isAppCall={isAppCall} /> */}
                      <Suspense fallback={<Loader />}>
                        <LazySponsor isAppCall={isAppCall} />
                      </Suspense>
                    </>
                  ) : null}
                </TabPane>

                {/* ------ exhibitor ------ */}
                <TabPane
                  tabId="4"
                  className={`${
                    outSideCall
                      ? ''
                      : 'scrollable-content- scrollbar-hide-no-maxheight'
                  }`}
                  style={{
                    height: deviceSize.isMobile
                      ? deviceSize.height - (isAppCall ? 130 : 220)
                      : deviceSize.height - 170
                  }}
                >
                  {activeTab == 4 ? (
                    <>
                      {/* <Exhibitor isAppCall={isAppCall} /> */}
                      <Suspense fallback={<Loader />}>
                        <LazyExhibitor isAppCall={isAppCall} />
                      </Suspense>
                    </>
                  ) : null}
                </TabPane>
              </TabContent>
            </div>
            {/* </Suspense> */}
          </>
        )
      ) : (
        <Loader />
      )}
    </>
  );
};

const mapStateToProps = state => {
  // console.log('state.eventTabs :- ', state.eventTabs);
  // console.log('state.userDetails :- ', state.userDetails);
  let isShowSpeaker = false;
  let isShowSponsor = false;
  let isShowExhibitor = false;
  let speakerText = '';
  let sponsorText = '';
  let exhibitorText = '';

  if (
    state.eventTabs &&
    state.eventTabs.length > 0 &&
    !_.isEmpty(state.userDetails) &&
    state.userDetails.speakeridfk
  ) {
    let matchSpeaker = _.filter(state.eventTabs, obj => {
      return obj.tabslected === 'speaker';
    });
    if (matchSpeaker.length > 0 && matchSpeaker[0].isenabled) {
      isShowSpeaker = true;
      speakerText = matchSpeaker[0].displaytabname;
    }
  }
  if (
    state.eventTabs &&
    state.eventTabs.length > 0 &&
    !_.isEmpty(state.userDetails) &&
    state.userDetails.sponsoridfk
  ) {
    let matchSponsor = _.filter(state.eventTabs, obj => {
      return obj.tabslected === 'sponsor';
    });
    if (matchSponsor.length > 0 && matchSponsor[0].isenabled) {
      isShowSponsor = true;
      sponsorText = matchSponsor[0].displaytabname;
    }
  }
  if (
    state.eventTabs &&
    state.eventTabs.length > 0 &&
    !_.isEmpty(state.userDetails) &&
    state.userDetails.exhibitoridfk
  ) {
    let matchExhibitor = _.filter(state.eventTabs, obj => {
      return obj.tabslected === 'exhibitor';
    });
    if (matchExhibitor.length > 0 && matchExhibitor[0].isenabled) {
      isShowExhibitor = true;
      exhibitorText = matchExhibitor[0].displaytabname;
    }
  }
  let isShowOnlyProfile =
    isShowSpeaker || isShowSponsor || isShowExhibitor ? false : true;

  return {
    session: state.session,
    eventTabs: state.eventTabs,
    userDetails: state.userDetails,
    isShowOnlyProfile,
    isShowSpeaker,
    isShowSponsor,
    isShowExhibitor,
    speakerText,
    sponsorText,
    exhibitorText,
    deviceSize: state.deviceSize
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchTickets,
      fetchMyProfile,
      fetchContentTabs,
      fetchEventForms,
      fetchInterests,
      fetchProductAllCategory,
      fetchProductAllSubCategory
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MyProfile);
